/* custom-finish.js — material hover → finish-click commit
 * - Materials (Paper/Metal/Acrylic) are never selected by clicking them
 * - Hover (desktop), tap (touch), or focus (keyboard) opens the finish list
 * - Clicking a finish is the single commit: checks the material radio,
 *   sets properties[Finish], shows the badge, enables Add to Cart
 * - On load nothing looks selected (is-uncommitted) and Add to Cart is
 *   disabled, but the default variant stays checked underneath so the
 *   theme's variant-radios machinery keeps working
 */
(function () {
  "use strict";

  // --- Config: finishes per material ---
  var FINISHES = {
    "Paper": ["Glossy", "Luster", "Metallic", "Fine Art"],
    "Metal": ["Gloss", "Satin", "Matte", "Smooth Silver", "Gloss Outdoor"],
    "Acrylic": ["White", "Metallic"]
  };

  var CLOSE_DELAY = 150; // ms grace before hover-out closes the list

  // --- helpers ---
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function ensureHiddenProperty(form, key) {
    var el = form.querySelector('input[name="properties[' + key + ']"]');
    if (el) return el;
    el = document.createElement('input');
    el.type = 'hidden';
    el.name = 'properties[' + key + ']';
    form.appendChild(el);
    return el;
  }

  function closeAllDropdowns(except) {
    $$('.pm-dropdown.open').forEach(function (dd) {
      if (dd !== except) dd.classList.remove('open');
    });
  }

  function removeAllFinishBadges(exceptLabel) {
    $$('.pm-finish-badge').forEach(function (b) {
      if (!exceptLabel || !exceptLabel.contains(b)) b.remove();
    });
  }

  function createDropdown(container) {
    var dd = document.createElement('div');
    dd.className = 'pm-dropdown';
    dd.setAttribute('role', 'listbox');
    dd.tabIndex = -1;
    dd.style.position = 'absolute';
    dd.style.top = '100%';
    dd.style.left = '0';
    dd.style.zIndex = '1000';
    dd.style.minWidth = '140px';

    var list = document.createElement('ul');
    list.className = 'pm-dropdown__list';
    list.style.listStyle = 'none';
    list.style.margin = '4px 0 0';
    list.style.padding = '0';
    list.style.border = '1px solid #d9d9d9';
    list.style.background = '#fff';
    list.style.boxShadow = '0 6px 16px rgba(0,0,0,.08)';

    dd.appendChild(list);
    container.appendChild(dd);
    return dd;
  }

  function populateDropdown(dd, material, onSelect) {
    var list = dd.querySelector('.pm-dropdown__list');
    list.innerHTML = '';
    (FINISHES[material] || []).forEach(function (finish) {
      var li = document.createElement('li');
      li.className = 'pm-dropdown__item';
      li.textContent = finish;
      li.setAttribute('role', 'option');
      li.style.padding = '8px 12px';
      li.style.cursor = 'pointer';
      li.tabIndex = 0;
      li.addEventListener('mouseenter', function () { li.style.background = '#f6f6f6'; });
      li.addEventListener('mouseleave', function () { li.style.background = '#fff'; });
      li.addEventListener('click', function (e) {
        e.stopPropagation();
        onSelect(finish);
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          e.stopPropagation();
          onSelect(finish);
        }
      });
      list.appendChild(li);
    });
  }

  function init() {
    var productForm = document.querySelector('form[action="/cart/add"]') || $('.product form');
    if (!productForm) return;

    var finishInput = ensureHiddenProperty(productForm, 'Finish');

    // --- Frame availability: hide the whole "Frame" option for Gloss Outdoor Metal
    // (Printing Material = Metal AND Finish = Gloss Outdoor). Force "No Frame" while hidden.
    function selectNoFrame() {
      var noFrame = document.querySelector('input[name="Frame"][value="No Frame"]');
      if (noFrame && !noFrame.checked) {
        noFrame.checked = true;
        noFrame.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function updateFrameVisibility() {
      var frameRadio = document.querySelector('input[name="Frame"]');
      if (!frameRadio) return; // product has no Frame option
      var fieldset = frameRadio.closest('.product-form__swatch');
      if (!fieldset) return;

      var selectedMaterial = document.querySelector('input[name="Printing Material"]:checked');
      var material = selectedMaterial ? selectedMaterial.value : '';
      var hide = material === 'Metal' && finishInput.value === 'Gloss Outdoor';

      fieldset.style.display = hide ? 'none' : '';
      if (hide) selectNoFrame();
    }

    var radios = $$('input[name="Printing Material"]');
    if (!radios.length) {
      updateFrameVisibility();
      return;
    }

    var materialFieldset = radios[0].closest('.product-form__swatch');
    var addButton = productForm.querySelector('button[name="add"]') || document.querySelector('.js-product-add');

    var state = {
      committed: false,          // true after the first finish click
      committedMaterial: null,   // material whose finish is currently chosen
      closeTimer: null,
      programmaticChange: false  // true while we check a radio ourselves
    };

    // dynamic checkout (Buy It Now / Shop Pay etc.) is injected asynchronously
    // by Shopify's JS into .shopify-payment-button, so it may not exist yet
    function getPaymentButtonContainer() {
      return productForm.querySelector('.shopify-payment-button') || document.querySelector('.shopify-payment-button');
    }

    function gatePaymentButton(container) {
      if (!container) return;
      container.style.pointerEvents = 'none';
      container.style.opacity = '.5';
    }

    function ungatePaymentButton(container) {
      if (!container) return;
      container.style.pointerEvents = '';
      container.style.opacity = '';
    }

    // While uncommitted we force-disable the button (that's the gate). On
    // commit we enable it once, here, and then commit()'s own subsequent
    // radio change-dispatch lets the theme recalculate real availability
    // (e.g. re-disable for a genuinely sold-out variant) afterwards — so
    // this never fights a legitimately sold-out button on load, since
    // syncButton() is only ever called with committed=false at that point.
    function syncButton() {
      if (addButton) addButton.disabled = !state.committed;
      var paymentButton = getPaymentButtonContainer();
      if (!state.committed) {
        gatePaymentButton(paymentButton);
      } else {
        ungatePaymentButton(paymentButton);
      }
    }

    // --- uncommitted state on load: suppress selected look, gate the button
    if (materialFieldset) materialFieldset.classList.add('is-uncommitted');
    syncButton();

    // if the theme re-enables the add button (e.g. a Size change triggers a
    // variant update) while still uncommitted, re-disable it. Always install
    // this — even if the button happens to be disabled (sold out) right now,
    // since switching Size later to an available variant must still be gated.
    if (addButton && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        if (!state.committed && !addButton.disabled) addButton.disabled = true;
      }).observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
    }

    // the payment button container is injected asynchronously and may be
    // replaced/re-rendered; observe the form for it appearing (or being
    // swapped) and (re)apply the gated state while uncommitted
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        if (!state.committed) gatePaymentButton(getPaymentButtonContainer());
      }).observe(productForm, { childList: true, subtree: true });
    }

    function containerOf(radio) {
      return radio.closest('.product-form__swatch__item') || radio.parentElement;
    }

    function openDropdown(radio) {
      var container = containerOf(radio);
      if (!container) return;
      if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
      var dd = container.querySelector('.pm-dropdown') || createDropdown(container);
      populateDropdown(dd, radio.value, function (finish) { commit(radio, finish); });
      closeAllDropdowns(dd);
      dd.classList.add('open');
    }

    function scheduleClose() {
      clearTimeout(state.closeTimer);
      state.closeTimer = setTimeout(function () { closeAllDropdowns(); }, CLOSE_DELAY);
    }

    function cancelClose() {
      clearTimeout(state.closeTimer);
    }

    // the single commit path: material + finish stick together, in one step
    function commit(radio, finish) {
      var label = document.querySelector('label[for="' + radio.id + '"]');

      if (state.committedMaterial !== radio.value) removeAllFinishBadges(label);

      finishInput.value = finish;
      state.committedMaterial = radio.value;
      state.committed = true;
      if (materialFieldset) materialFieldset.classList.remove('is-uncommitted');
      syncButton(); // enable before the theme recalculates availability

      state.programmaticChange = true;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true })); // theme updates variant/price/images
      state.programmaticChange = false;

      if (label) {
        var badge = label.querySelector('.pm-finish-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'pm-finish-badge';
          badge.style.marginLeft = '8px';
          badge.style.fontSize = '12px';
          badge.style.opacity = '0.85';
          label.appendChild(badge);
        }
        badge.textContent = '- ' + finish;
      }

      updateFrameVisibility();
      closeAllDropdowns();
    }

    radios.forEach(function (radio) {
      var container = containerOf(radio);
      var label = document.querySelector('label[for="' + radio.id + '"]');

      // hover (desktop): the dropdown is appended INSIDE the container, so
      // container mouseleave only fires once the pointer has left both the
      // label and the open list — no hover-bridge needed
      if (container) {
        container.addEventListener('mouseenter', function () { cancelClose(); openDropdown(radio); });
        container.addEventListener('mouseleave', scheduleClose);
      }

      // click/tap never selects the material — it only opens the list
      // (this is the touch path; on desktop hover has usually opened it already)
      if (label) {
        label.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openDropdown(radio);
        });
      }

      // space on the focused (visually hidden) radio fires a click — block it.
      // Also stop it bubbling to the document-level closeAllDropdowns
      // listener, otherwise Space closes the very list that focus just opened.
      radio.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });

      // keyboard parity with hover: focusing a radio opens its list
      radio.addEventListener('focus', function () { openDropdown(radio); });

      // any material change we didn't trigger (e.g. arrow keys within the
      // radio group) is reverted to the last committed / default material
      radio.addEventListener('change', function () {
        if (state.programmaticChange) return;
        var revertTo = null;
        if (state.committedMaterial) {
          revertTo = radios.filter(function (r) { return r.value === state.committedMaterial; })[0];
        } else {
          revertTo = radios.filter(function (r) { return r.defaultChecked; })[0];
        }
        if (revertTo && !revertTo.checked) {
          state.programmaticChange = true;
          revertTo.checked = true;
          revertTo.dispatchEvent(new Event('change', { bubbles: true }));
          state.programmaticChange = false;
        }
        openDropdown(radio); // show the finish list they need to click instead
      });
    });

    // outside click / Escape closes any open list
    document.addEventListener('click', function () { closeAllDropdowns(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDropdowns();
    });

    // correct Frame visibility for the initial (uncommitted) state
    updateFrameVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
